let audio = null;

export const startBackgroundTone = () => {
  if (audio) return; // prevent duplicate play

  audio = new Audio("/assets/sounds/music.mp3");
  // audio = new Audio("/assets/sounds/keyboard-typing-sound-effect-335503.mp3");

  audio.loop = true;
  audio.volume = 0.4;

  audio
    .play()
    .catch((err) => console.warn("Background tone play failed:", err));
};

export const stopBackgroundTone = () => {
  if (!audio) return;

  audio.pause();
  audio.currentTime = 0;
  audio = null;
};
